
import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'

import {
  DISABLE_DOOR_ACCESSES_REQUEST, DISABLE_DOOR_ACCESSES_RESPONSE, DISABLE_DOOR_ACCESSES_RESPONSE_ERROR,
  ENABLE_DOOR_ACCESSES_REQUEST, ENABLE_DOOR_ACCESSES_RESPONSE, ENABLE_DOOR_ACCESSES_RESPONSE_ERROR,
  ADD_COMMUNITY_DOOR_ACCESSES_REQUEST,
  ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE,
  ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR,
  ADD_UNIT_DOOR_ACCESSES_REQUEST,
  ADD_UNIT_DOOR_ACCESSES_RESPONSE,
  ADD_UNIT_DOOR_ACCESSES_RESPONSE_ERROR,
  FETCH_DOOR_ACCESS_REQUEST, FETCH_DOOR_ACCESS_RESPONSE, FETCH_DOOR_ACCESS_RESPONSE_ERROR,
  LIST_COMMUNITY_DOOR_ACCESSES_REQUEST,
  LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE,
  LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR,
  LIST_COMMUNITY_DOOR_ACCESS_IDS_REQUEST,
  LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE,
  LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE_ERROR,
  LIST_UNIT_DOOR_ACCESS_IDS_REQUEST, LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE, LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE_ERROR,
  SAVE_DOOR_ACCESS_REQUEST, SAVE_DOOR_ACCESS_RESPONSE, SAVE_DOOR_ACCESS_RESPONSE_ERROR,
  REMOVE_DOOR_ACCESSES_REQUEST, REMOVE_DOOR_ACCESSES_RESPONSE, REMOVE_DOOR_ACCESSES_RESPONSE_ERROR,
  REMOVE_COMMUNITY_DOOR_ACCESS_REQUEST,
  REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE,
  REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE_ERROR,
  REMOVE_UNIT_DOOR_ACCESS_REQUEST, REMOVE_UNIT_DOOR_ACCESS_RESPONSE, REMOVE_UNIT_DOOR_ACCESS_RESPONSE_ERROR,
  SET_DIALOG_EDIT_DOOR_ACCESS_USER, CLEAR_DIALOG_EDIT_DOOR_ACCESS_USER,
  SET_DIALOG_GRANT_DOOR_ACCESS_USER_IDS, CLEAR_DIALOG_GRANT_DOOR_ACCESS_USER_IDS,
} from '../constants'

function getListLoaderId(action) {
  if (action.unitId) {
    return action.unitId
  }
  if (action.communityId) {
    return action.communityId
  }
  return ''
}

function getCommunityAccessLoaderId(action) {
  return action.communityId
}

function getUnitAccessLoaderId(action) {
  return action.unitId
}

export function saveDoorAccess(doorAccess) {
  return (dispatch) => {
    dispatch({ type: SAVE_DOOR_ACCESS_REQUEST, access: doorAccess })

    axios.put(`${CONFIG.apiBase}/door_accesses/${doorAccess.id}`, doorAccess).then((response) => {
      dispatch({
        type: SAVE_DOOR_ACCESS_RESPONSE,
        access: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error)
      dispatch({
        type: SAVE_DOOR_ACCESS_RESPONSE_ERROR,
        error,
        access: {
          id: doorAccess.id,
        },
      })
    })
  }
}

export function removeDoorAccesses(maybeParsedCommunityId, maybeParsedAccessIds) {
  const communityId = parseInt(maybeParsedCommunityId, 10)
  const accessIds = maybeParsedAccessIds.map((id) => parseInt(id, 10))

  return (dispatch) => {
    if (accessIds.length) {
      dispatch({
        type: REMOVE_DOOR_ACCESSES_REQUEST,
        communityId,
        getLoaderId: getCommunityAccessLoaderId,
        accessIds,
      })

      axios.delete(`${CONFIG.apiBase}/door_accesses?ids=${accessIds.join('&ids=')}`).then((response) => {
        dispatch({
          type: REMOVE_DOOR_ACCESSES_RESPONSE,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accessIds: response.data.body.map((a) => a.id),
        })
      }).catch((error) => {
        // TODO: error handling
        // console.log(error)
        dispatch({
          type: REMOVE_DOOR_ACCESSES_RESPONSE_ERROR,
          error,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accessIds: [],
        })
      })
    }
  }
}

export function disableDoorAccesses(maybeParsedCommunityId, maybeParsedAccessIds) {
  const communityId = parseInt(maybeParsedCommunityId, 10)
  const accessIds = maybeParsedAccessIds.map((id) => parseInt(id, 10))

  return (dispatch) => {
    if (accessIds.length) {
      dispatch({
        type: DISABLE_DOOR_ACCESSES_REQUEST,
        communityId,
        getLoaderId: getCommunityAccessLoaderId,
        accessIds,
      })

      const payload = accessIds.map((id) => ({ id, enabled: false }))
      axios.put(`${CONFIG.apiBase}/door_accesses`, payload).then((response) => {
        dispatch({
          type: DISABLE_DOOR_ACCESSES_RESPONSE,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accesses: response.data.body,
        })
      }).catch((error) => {
        // TODO: error handling
        dispatch({
          type: DISABLE_DOOR_ACCESSES_RESPONSE_ERROR,
          error,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accesses: [],
        })
      })
    }
  }
}

export function enableDoorAccesses(maybeParsedCommunityId, maybeParsedAccessIds) {
  const communityId = parseInt(maybeParsedCommunityId, 10)
  const accessIds = maybeParsedAccessIds.map((id) => parseInt(id, 10))

  return (dispatch) => {
    if (accessIds.length) {
      dispatch({
        type: ENABLE_DOOR_ACCESSES_REQUEST,
        communityId,
        getLoaderId: getCommunityAccessLoaderId,
        accessIds,
      })

      const payload = accessIds.map((id) => ({ id, enabled: true }))
      axios.put(`${CONFIG.apiBase}/door_accesses`, payload).then((response) => {
        dispatch({
          type: ENABLE_DOOR_ACCESSES_RESPONSE,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accesses: response.data.body,
        })
      }).catch((error) => {
        // TODO: error handling
        // console.log(error)
        dispatch({
          type: ENABLE_DOOR_ACCESSES_RESPONSE_ERROR,
          error,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accesses: [],
        })
      })
    }
  }
}

export function addCommunityDoorAccesses(maybeParsedCommunityId, maybeParsedAccessIds) {
  const communityId = parseInt(maybeParsedCommunityId, 10)
  const accessIds = maybeParsedAccessIds.map((id) => parseInt(id, 10))

  return (dispatch) => {
    if (accessIds.length) {
      dispatch({
        type: ADD_COMMUNITY_DOOR_ACCESSES_REQUEST,
        communityId,
        getLoaderId: getCommunityAccessLoaderId,
        accessIds,
      })

      axios.post(`${CONFIG.apiBase}/communities/${communityId}/door_accesses`, accessIds).then((response) => {
        dispatch({
          type: ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accessIds: response.data.body,
        })
      }).catch((error) => {
        // TODO: error handling
        // console.log(error)
        dispatch({
          type: ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR,
          error,
          communityId,
          getLoaderId: getCommunityAccessLoaderId,
          accessIds: [],
        })
      })
    }
  }
}

export function addUnitDoorAccesses(maybeParsedUnitIds, maybeParsedAccessIds) {
  const unitIds = maybeParsedUnitIds.map((id) => parseInt(id, 10))
  const accessIds = maybeParsedAccessIds.map((id) => parseInt(id, 10))

  return (dispatch) => {
    if (accessIds.length) {
      unitIds.forEach((unitId) => {
        dispatch({
          type: ADD_UNIT_DOOR_ACCESSES_REQUEST,
          unitId,
          getLoaderId: getUnitAccessLoaderId,
          accessIds,
        })
      })

      Promise.all(
        unitIds.map((unitId) => axios.post(`${CONFIG.apiBase}/units/${unitId}/door_accesses`, accessIds)),
      ).then(
        (responses) => {
          responses.forEach((response, index) => {
            if (response.status === 200) {
              dispatch({
                type: ADD_UNIT_DOOR_ACCESSES_RESPONSE,
                unitId: unitIds[index],
                getLoaderId: getUnitAccessLoaderId,
                accessIds: response.data.body,
              })
            } else {
              // TODO: handle error
              dispatch({
                type: ADD_UNIT_DOOR_ACCESSES_RESPONSE_ERROR,
                error: true,
                unitId: unitIds[index],
                getLoaderId: getUnitAccessLoaderId,
                accessIds: [],
              })
            }
          })
        },
      ).catch((error) => {
        // TODO: error handling
        // console.log(error)
        unitIds.forEach((unitId) => {
          dispatch({
            type: ADD_UNIT_DOOR_ACCESSES_RESPONSE_ERROR,
            error,
            unitId,
            getLoaderId: getUnitAccessLoaderId,
            accessIds: [],
          })
        })
      })
    }
  }
}

export function addDoorAccess(doorAccess, maybeParsedUnitId = null) {
  return (dispatch) => {
    dispatch({
      type: SAVE_DOOR_ACCESS_REQUEST,
      access: doorAccess,
      isNew: true,
    })

    axios.post(`${CONFIG.apiBase}/door_accesses`, doorAccess).then((response) => {
      const access = response.data.body
      dispatch({
        type: SAVE_DOOR_ACCESS_RESPONSE,
        access,
        isNew: true,
      })
      if (maybeParsedUnitId) {
        const unitId = parseInt(maybeParsedUnitId, 10)
        dispatch(addUnitDoorAccesses([unitId], [access.id]))
      }
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_DOOR_ACCESS_RESPONSE_ERROR,
        error,
        access: {},
        isNew: true,
      })
    })
  }
}

export function removeCommunityDoorAccess(maybeParsedCommunityId, maybeParsedAccessId) {
  const communityId = parseInt(maybeParsedCommunityId, 10)
  const accessId = parseInt(maybeParsedAccessId, 10)

  function getLoaderId(action) {
    return [action.communityId, action.accessId]
  }

  return (dispatch) => {
    dispatch({
      type: REMOVE_COMMUNITY_DOOR_ACCESS_REQUEST,
      communityId,
      accessId,
      getLoaderId,
    })

    axios.delete(`${CONFIG.apiBase}/communities/${communityId}/door_accesses/${accessId}`).then(() => {
      dispatch({
        type: REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE,
        communityId,
        accessId,
        getLoaderId,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE_ERROR,
        error,
        communityId,
        accessId,
        getLoaderId,
      })
    })
  }
}

export function removeUnitDoorAccess(maybeParsedUnitId, maybeParsedAccessId) {
  const unitId = parseInt(maybeParsedUnitId, 10)
  const accessId = parseInt(maybeParsedAccessId, 10)

  function getLoaderId(action) {
    return [action.unitId, action.accessId]
  }

  return (dispatch) => {
    dispatch({
      type: REMOVE_UNIT_DOOR_ACCESS_REQUEST,
      unitId,
      accessId,
      getLoaderId,
    })

    axios.delete(`${CONFIG.apiBase}/units/${unitId}/door_accesses/${accessId}`).then(() => {
      dispatch({
        type: REMOVE_UNIT_DOOR_ACCESS_RESPONSE,
        unitId,
        accessId,
        getLoaderId,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: REMOVE_UNIT_DOOR_ACCESS_RESPONSE_ERROR,
        error,
        unitId,
        accessId,
        getLoaderId,
      })
    })
  }
}

export function listCommunityDoorAccessIds(maybeParsedCommunityId) {
  const communityId = parseInt(maybeParsedCommunityId, 10)

  return (dispatch, getState) => {
    if (isCachedItem(getState().doorAccessesByCommunity, communityId)) {
      return
    }

    dispatch({
      type: LIST_COMMUNITY_DOOR_ACCESS_IDS_REQUEST,
      communityId,
      getLoaderId: getListLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/communities/${communityId}/door_access_ids`).then((response) => {
      // response.data.body could be null, handle appropriately
      if (response.data.body && !response.data.body.error) {
        dispatch({
          type: LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE,
          communityId,
          getLoaderId: getListLoaderId,
          accessIds: response.data.body,
        })
      } else {
        // TODO: handle error - surface an error message
        dispatch({
          type: LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE_ERROR,
          error: true,
          communityId,
          getLoaderId: getListLoaderId,
          accessIds: [],
        })
      }
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE_ERROR,
        error,
        communityId,
        getLoaderId: getListLoaderId,
        accessIds: [],
      })
    })
  }
}

export function listUnitDoorAccessIds(maybeParsedUnitId) {
  const unitId = parseInt(maybeParsedUnitId, 10)

  return (dispatch, getState) => {
    if (isCachedItem(getState().doorAccessesByUnit, unitId)) {
      return
    }

    dispatch({
      type: LIST_UNIT_DOOR_ACCESS_IDS_REQUEST,
      unitId,
      getLoaderId: getListLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/units/${unitId}/door_access_ids`).then((response) => {
      // response.data.body could be null, handle appropriately
      let accessIds = []
      if (response.data.body && !response.data.body.error) {
        accessIds = response.data.body
      }

      dispatch({
        type: LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE,
        unitId,
        getLoaderId: getListLoaderId,
        accessIds,
      })
    }).catch((error) => {
      dispatch({
        type: LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE_ERROR,
        error,
        unitId,
        getLoaderId: getListLoaderId,
        accessIds: [],
      })
    })
  }
}

export function getDoorAccess(maybeParsedAccessId) {
  const accessId = parseInt(maybeParsedAccessId, 10)

  return (dispatch, getState) => {
    if (isCachedItem(getState().doorAccesses, accessId)) {
      return
    }

    dispatch({
      type: FETCH_DOOR_ACCESS_REQUEST,
      accessId,
    })

    axios.get(`${CONFIG.apiBase}/door_accesses/${accessId}`).then((response) => {
      dispatch({
        type: FETCH_DOOR_ACCESS_RESPONSE,
        doorAccess: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error)
      dispatch({
        type: FETCH_DOOR_ACCESS_RESPONSE_ERROR,
        error,
        accessId,
      })
    })
  }
}

export function listCommunityDoorAccesses(maybeParsedCommunityId) {
  const communityId = parseInt(maybeParsedCommunityId, 10)

  return (dispatch /* getState */) => {
    // TODO: only check if cached on a unit route, otherwise, always fetch
    // if (isCachedItem(getState().doorAccessUsersByCommunity, cId)) {
    //   return
    // }
    dispatch({
      type: LIST_COMMUNITY_DOOR_ACCESSES_REQUEST,
      communityId,
      getLoaderId: getListLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/door_accesses?community_id=${communityId}`).then((response) => {
      const doorAccesses = response.data.body ? response.data.body.sort((a, b) => a.name.localeCompare(b.name)) : []

      dispatch({
        type: LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE,
        communityId,
        getLoaderId: getListLoaderId,
        doorAccesses,
        perms: response.data.perms,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR,
        error,
        communityId,
        getLoaderId: getListLoaderId,
        doorAccesses: [],
        perms: null,
      })
    })
  }
}

export function setEditDoorAccessUser(maybeParsedAccessId, name = '') {
  // name param is optional and only used for creating a new user
  const accessId = parseInt(maybeParsedAccessId, 10)

  return (dispatch) => {
    dispatch({ type: SET_DIALOG_EDIT_DOOR_ACCESS_USER, accessId, name })
  }
}

export function clearEditDoorAccessUser() { // call this on dialog close
  return (dispatch) => {
    dispatch({ type: CLEAR_DIALOG_EDIT_DOOR_ACCESS_USER })
  }
}

export function setGrantDoorAccessUserIds(accessIds) {
  return (dispatch) => {
    dispatch({
      type: SET_DIALOG_GRANT_DOOR_ACCESS_USER_IDS,
      accessIds,
    })
  }
}

export function clearGrantDoorAccessUserIds() {
  return (dispatch) => {
    dispatch({ type: CLEAR_DIALOG_GRANT_DOOR_ACCESS_USER_IDS })
  }
}
